<div class="members-page">
  <form [formGroup]="form" (ngSubmit)="addMember()">
    <div class="addemail">
      <div class="input-wrapper email-wrapper">
        <label>Email Addresses</label>
        <input
          class="input"
          clearInput
          #email
          type="text"
          inputmode="email"
          formControlName="email"
          placeholder="Type or paste email addresses"
          (paste)="onEmailPaste($event)"
          (blur)="form.get('email').setValue(normalizeEmailList(form.get('email').value))"
        />
        <span class="email-hint">Separate addresses with semicolons, commas, spaces, or new lines.</span>
      </div>
      <app-disabled-feature-upsell
        *ngIf="topupEnabled && isSuperAdmin"
        class="allowance-disabled-upsell"
        title="Per-member monthly allowance is disabled"
        description="This control is visible for super admins, but updates are currently disabled."
        pillMode="relative"
        pillPosition="inline"
      >
        <div class="input-wrapper allowance-wrapper allowance-wrapper-disabled">
          <label>Monthly Allowance ($)</label>
          <input
            class="input"
            clearInput
            #allowance
            type="text"
            formControlName="allowance"
            (keypress)="validateNumber($event)"
            (paste)="validatePaste($event)"
            (blur)="formatCurrency()"
            [placeholder]="(currentWellspace.amount || 0) | currency"
          />
        </div>
      </app-disabled-feature-upsell>
      <button
        mat-raised-button
        color="primary"
        [disabled]="!form.valid || uploading"
        class="addbutton"
        type="submit"
      >
        Add
      </button>
    </div>
  </form>

  <mat-divider></mat-divider>

  <div class="upload-section">
    <div class="upload-copy">
      <span class="info">
        Upload a CSV or XLSX file with a header row. Supported column headers are
        <ng-container *ngFor="let column of teamMemberUploadColumns; let last = last">
          <strong>{{ column }}</strong
          ><span *ngIf="!last">, </span>
        </ng-container>.
        <ng-container *ngFor="let column of requiredUploadColumns; let last = last">
          <strong>{{ column }}</strong
          ><span *ngIf="!last">, </span>
        </ng-container>
        {{ requiredUploadColumnVerb }} required. The other supported columns are
        optional and may appear in any order.
      </span>
      <span class="info">
        Use this template to format your member upload.
        <a download="Wallit-team-members-upload-template.csv" target="_blank" [href]="uploadTemplateUrl">
          Download template
        </a>
      </span>
    </div>
    <app-fileupload
      class="uploadarea"
      requiredFileType=".csv,.xlsx"
      (doneEvent)="uploadMembers($event)"
    ></app-fileupload>
    <div
      class="error infosection"
      *ngIf="result && result.newCount === 0 && result.invalidEmail?.length > 0 && result.alreadyMember?.length === 0"
    >
      <span class="infosection">Invalid File Format</span>
      <span
        ><br /><br />Upload a CSV or XLSX file with a header row. Supported column headers are
        {{ teamMemberUploadColumnList }}. {{ requiredUploadColumnList }} {{ requiredUploadColumnVerb }} required.</span
      >
    </div>
    <div
      class="section"
      *ngIf="result && result.invalidEmail && (result.alreadyMember?.length > 0 || result.newCount > 0)"
    >
      <span class="infosection">Invalid Email Address</span>
      <span *ngFor="let info of result.invalidEmail">Line {{info.line}}: {{info.email}}</span>
    </div>
    <div class="section" *ngIf="result && result.alreadyMember?.length > 0">
      <span class="infosection">Already a Member</span>
      <span *ngFor="let info of result.alreadyMember">Line {{info.line}}: {{info.email}}</span>
    </div>
    <div class="section error upload-error-box" *ngIf="result && result.errorDetails?.length > 0">
      <span class="infosection">{{ result.errorMessage || 'Upload Error' }}</span>
      <span *ngFor="let info of getConsolidatedUploadErrorDetails()">
        Line {{ info.lineNumber }}: {{ info.type }}<span *ngIf="info.info">: {{ info.info }}</span>
      </span>
    </div>
  </div>

  <div class="members-list-shell">
    <mat-divider></mat-divider>
    <div class="list">
      <div class="list-toolbar">
        <mat-button-toggle-group
          class="member-view-toggle"
          [(value)]="memberView"
          aria-label="Member status"
        >
          <mat-button-toggle value="current">Current ({{ members.length }})</mat-button-toggle>
          <mat-button-toggle value="removed">Removed ({{ removedMembers.length }})</mat-button-toggle>
        </mat-button-toggle-group>
        <div class="buttons">
          <button
            class="exportbutton"
            mat-raised-button
            color="accent"
            (click)="exporter.exportTable('csv', {fileName: currentWellspace.name})"
          >
            <mat-icon>file_download</mat-icon>Export to CSV
          </button>
          <!--
            <button class="exportbutton" mat-raised-button color="accent" (click)="exportCensus()"><mat-icon>file_download</mat-icon>Export Census</button>
            -->
          <app-send-invites-button
            [teamId]="getTeamId()"
            [pendingInvitesCount]="pendingInvitesCount"
            [hasPendingAutomation]="hasPendingInviteAutomation"
            (invitesSent)="loadTeamMembers()"
          ></app-send-invites-button>
        </div>
      </div>
      <mat-table
        class="hiddentable"
        matTableExporter
        [dataSource]="visibleMembers"
        #exporter="matTableExporter"
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let item">
            {{ getMemberDisplayName(item) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let item">{{ getMemberDisplayEmail(item) }}</td>
        </ng-container>
        <ng-container matColumnDef="invitation">
          <th mat-header-cell *matHeaderCellDef>Invitation</th>
          <td mat-cell *matCellDef="let item">
            {{ item.inviteAcceptedAt ? 'Accepted' : (item.inviteSentAt ? 'Invitation Sent' : 'Not Sent') }}
          </td>
        </ng-container>
        <ng-container matColumnDef="wallitbalance">
          <th mat-header-cell *matHeaderCellDef>Wallit Balance</th>
          <td mat-cell *matCellDef="let item">{{item.wallitBalance | currency}}</td>
        </ng-container>
        <ng-container matColumnDef="balance">
          <th mat-header-cell *matHeaderCellDef>Allowance Balance</th>
          <td mat-cell *matCellDef="let item">{{item.balance | currency}}</td>
        </ng-container>
        <ng-container matColumnDef="p2pbalance">
          <th mat-header-cell *matHeaderCellDef>P2P Balance</th>
          <td mat-cell *matCellDef="let item">{{item.p2pBalance | currency}}</td>
        </ng-container>
        <ng-container matColumnDef="employmentDate">
          <th mat-header-cell *matHeaderCellDef>Employment Date</th>
          <td mat-cell *matCellDef="let item">{{item.employmentDate | date: 'mediumDate'}}</td>
        </ng-container>
        <ng-container matColumnDef="memberCreatedAt">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let item">{{item.memberCreatedAt | date: 'mediumDate'}}</td>
        </ng-container>
        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef>Role</th>
          <td mat-cell *matCellDef="let item">{{item.role}}</td>
        </ng-container>
        <ng-container matColumnDef="canReceiveAllowance">
          <th mat-header-cell *matHeaderCellDef>Allowance</th>
          <td mat-cell *matCellDef="let item">
            {{item.canReceiveAllowance === 1 ? 'Enabled' : 'Disabled'}}
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="['name','email','invitation','wallitbalance','balance','p2pbalance','employmentDate','memberCreatedAt','role','canReceiveAllowance']"
        ></tr>
        <tr
          mat-row
          *matRowDef="let rows; columns: ['name','email','invitation','wallitbalance','balance','p2pbalance','employmentDate','memberCreatedAt','role','canReceiveAllowance']"
        ></tr>
      </mat-table>
      <app-inlinemessage
        *ngIf="memberView === 'removed' && removedMembers.length === 0 && !isLoadingMembers"
        class="no-removed-members"
        level="info"
        message="There are no removed members in this workspace"
      ></app-inlinemessage>
      <div class="card" *ngFor="let member of visibleMembers">
        <app-user-item
          (memberChangedEvent)="loadTeamMembers()"
          class="useritem"
          [showHeader]="member === visibleMembers[0]"
          [team]="currentWellspace"
          [wallitBalance]="isAdmin"
          [member]="member"
          [detail]="true"
          [readOnly]="memberView === 'removed'"
        ></app-user-item>
      </div>
    </div>
  </div>
</div>
